import cn from "classnames";

import { useLoc } from "@app/shared/lib/hooks";

import styles from "./Badge.module.scss";

const FolderBadge: React.FC = () => {
  const loc = useLoc();

  return (
    <div
      className={cn(
        styles.folder_badge,
        "absolute shadow-sm",
        "material-card-folder-badge",
      )}
      data-testid="folder-badge"
    >
      {loc.word("Course.folderLabel", { default: "Folder" })}
    </div>
  );
};

export default FolderBadge;
